import { Box, Typography } from '@mui/material';
import { RHFCheckbox } from 'src/components/minimals/form';
import { AssignedAlarmTag } from 'src/types/assets';
import { TitleDescription } from '../TitleDescription';

type Props = {
  assetProperties: AssignedAlarmTag[];
  typeOfAssetForMessage: string;
  typeOfAsset: string;
};

export const DisplayedAssetProperties = ({
  assetProperties,
  typeOfAssetForMessage,
  typeOfAsset,
}: Props) => (
  <Box>
    <TitleDescription>Display Asset Properties</TitleDescription>
    {!assetProperties.length && (
      <Box sx={{ padding: '1rem 0' }}>
        <Typography sx={{ fontSize: '0.8rem' }}>
          No properties have been mapped for {typeOfAssetForMessage} asset.
        </Typography>
      </Box>
    )}
    <Box>
      {assetProperties?.map((property) => {
        const propertyId = property.id;
        const tagName = property.alarmTagName ?? property.alarmTagName;

        return (
          <RHFCheckbox
            key={propertyId}
            name={`assetProperties.${typeOfAsset}.${propertyId}`}
            testId={`checkbox-${typeOfAsset}-${tagName}`}
            label={tagName}
          />
        );
      })}
    </Box>
  </Box>
);
